export default __webpack_public_path__ + "static/media/tamGiangAvgLength.2af5a3d3.png";